var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vueSelect',{attrs:{"options":_vm.resp.categorias,"label":"nombre","placeholder":"Todas"},on:{"input":_vm.getCategoria},scopedSlots:_vm._u([{key:"no-options",fn:function(ref){
var search = ref.search;
var searching = ref.searching;
return [(searching)?[_vm._v(" No se encontraron resultados para "),_c('em',[_vm._v(_vm._s(search))]),_vm._v(". ")]:_c('em',{staticStyle:{"opacity":"0.5"}})]}}])},[_c('option',{key:"0",attrs:{"value":"Todas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }